import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule, RouterOutlet, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { User } from './models/user';
import { UserService } from './services/api/user/user.service';
import { MatIconModule } from '@angular/material/icon';

import { YshMainAsideComponent } from "./components/ysh-main-aside/ysh-main-aside.component";
import { YshMainHeaderComponent } from "./components/ysh-main-header/ysh-main-header.component";
import { YshToastComponent } from "./components/ysh-toast/ysh-toast.component";
import { ToastService } from './services/ui/toast/toast.service';
import { YshDialogComponent } from './components/ysh-dialog/ysh-dialog.component';
import { LoadingService } from './services/ui/loading/loading.service';
import { YshDotsComponent } from "./components/ysh-dots/ysh-dots.component";
import { AppVersionService } from './services/app-version.service';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    RouterModule,
    RouterOutlet,
    MatIconModule,
    YshMainAsideComponent,
    YshMainHeaderComponent,
    YshToastComponent,
    YshDialogComponent,
    YshDotsComponent
]
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'partner-portal';
  activeMobileMenu = false;
  hasFramelessLayout = false;
  isLoading = false;
  isLoggedIn = false;
  currentUser: User;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private userService: UserService,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private appVersionService: AppVersionService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.userService.loggedIn$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(isLoggedIn => (this.isLoggedIn = isLoggedIn));
    this.userService.currentUser$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(user => (this.currentUser = user));

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() =>
        this.hasFramelessLayout = !!this.activatedRoute.firstChild?.snapshot.data?.hasFramelessLayout
      );
  }
  
  ngOnInit() {
    this.appVersionService.start();
    this.initLoadingState();
    this.showLogoutToast();
  }
  
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private initLoadingState() {
    this.loadingService.loading$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(loading => this.isLoading = loading);
  }

  private showLogoutToast() {
    if (localStorage.getItem('showLogoutToast')) {
      this.toastService.show('success','Successful Logout');
      localStorage.removeItem('showLogoutToast');
    }
  }

  didTapLogout() {
    this.userService.logout(true);
    localStorage.setItem('showLogoutToast','true');
  }

  didTapMobileMenu() {
    this.activeMobileMenu = !this.activeMobileMenu;
  }
}
